import FormValidator from 'utils/FormValidator';

/**
 * Pure email-or-phone credential normalizer (SIM-2 / ACS-4126, BR-006 v4.1).
 *
 * Classifies a single free-text credential into EXACTLY one of three outcomes
 * using a digit-heuristic-first strategy (TAD-SIM2-001):
 *
 *   { type: 'email', value: <lowercased email> }    (BR-005)
 *   { type: 'phone', value: <bare 10 NANP digits> } (BR-006 v4.1 — no +1 prefix)
 *   { type: 'invalid' }                             (no `value`)
 *
 * Strategy: strip standard phone formatting (spaces, parens, dashes via
 * FormValidator.getRawPhoneNumber, plus dots which that helper does not remove).
 * If the stripped value is all digits it is a phone attempt — accepted only when
 * it is exactly FIELD_LENGTHS.phone (10) digits, so any country code (leading-1,
 * +1, +44, +52) or wrong length is invalid. Otherwise it is an email attempt,
 * validated against the ORIGINAL input via FormValidator.isValidEmailAddress.
 *
 * There is no `non_nanp_international` outcome and no AC-031 international branch.
 * The raw value is never logged (BR-021).
 */
const normalize = input => {
    if (!input || !input.trim()) {
        return { type: 'invalid' };
    }

    const stripped = FormValidator.getRawPhoneNumber(input).replace(/\./g, '');

    if (/^\d+$/.test(stripped)) {
        if (stripped.length === FormValidator.FIELD_LENGTHS.phone) {
            return { type: 'phone', value: stripped };
        }

        return { type: 'invalid' };
    }

    if (FormValidator.isValidEmailAddress(input)) {
        return { type: 'email', value: input.toLowerCase() };
    }

    return { type: 'invalid' };
};

export default normalize;
